import * as React from "react";
import {css, cx} from "emotion";
import {mix} from "polished";

import "./style-filter.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {Tooltip} from "../../../../common/tool-tip";

export const StyleFilter = ({items, count, reversed, onClear}) => cs(
    consumeContext("themeScheme"),
    ({themeScheme}) => (
        <div className="style-filter style-filter-2u1">
            <div className="content">
                {FilterLines({items, onClear})}

                {/*<BarSvg className="bar" fill={themeScheme.primary2}/>*/}

                {/*<div className={cx("thin-line",*/}
                {/*    css`*/}
                {/*        & > * {*/}
                {/*            border-left: 1px solid ${themeScheme.primary2};*/}
                {/*            color: ${themeScheme.primary2};*/}
                {/*        }*/}
                {/*    `*/}
                {/*)}>*/}
                {/*    <div className="filter-icon" style={{background: themeScheme.primary2}}>*/}
                {/*        <img src={require("./filter-icon.svg")}/>*/}
                {/*    </div>*/}

                {/*    <div*/}
                {/*        className="sorting"*/}
                {/*        onClick={() => reversed.onChange(!reversed.value)}*/}
                {/*    >*/}
                {/*        <i className="fa fa-long-arrow-up"  />*/}
                {/*        <i className="fa fa-long-arrow-down"/>*/}
                {/*    </div>*/}

                {/*    <div className="count">*/}
                {/*        {count}*/}
                {/*    </div>*/}

                {/*    <div className="view-size">*/}
                {/*        {[gripSmall, gripMedium].map((grip, i) => {*/}
                {/*            const active = i === 1;*/}
                {/*            return (*/}
                {/*                <div*/}
                {/*                    key={i}*/}
                {/*                    className={cx("grip", {active}, css`*/}
                {/*                        &.active {*/}
                {/*                            background: ${themeScheme.primary2};*/}
                {/*                        }*/}
                {/*                    `)}*/}
                {/*                >*/}
                {/*                    {grip({fill: active ? "white" : themeScheme.primary2})}*/}
                {/*                </div>*/}
                {/*            );*/}
                {/*        })}*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
        </div>
    )
);


const FilterLines = ({items, onClear}) => cs(
    consumeContext("themeScheme"),
    ({themeScheme}) => (
        <div className="filter-lines">
            <Tooltip/>

            {cs(
                ({}, next) => (
                    <table>
                        <tbody>
                        {next()}
                        </tbody>
                    </table>
                ),
                ({}) => (items ? toMultiLines(items) : []).map((line, lineIndex) => (
                    <tr className="line" key={lineIndex}>
                        {(lineIndex>=2 ? line : [
                            ...line,
                            lineIndex === 0 ? {
                                label: "All",
                                selected: items.find((i) => i.selected) == null,
                                onClick: onClear,
                            } : {
                                label: "Clear",
                                onClick: onClear,
                            },
                        ]).map((item, j) => (
                            <td
                                className={cx(
                                    "item",
                                    {selected: item.selected},
                                    css`
                                        background: ${mix(0.9, "white", themeScheme.xpresso.menuBackgroundColorShadow)};
                                        &:hover {
                                          background: ${mix(0.8, "white", themeScheme.xpresso.menuBackgroundColorShadow)};
                                        }
                                        &.selected {
                                            background: ${mix(0.1, "white", themeScheme.xpresso.menuBackgroundColorShadow)};
                                        }
                                    `
                                )}
                                xd-qa-type="style_filter"
                                key={j}
                                onClick={item.onClick}
                                data-tip={item.label}
                            >
                                {item.label}
                            </td>
                        ))}
                    </tr>
                )),
            )}
        </div>
    )
);

export const toMultiLines = (items) => {
    const tilesPerRow = window.innerWidth < 1920 ?
        Math.floor((window.innerWidth - 400) / 105) - 1:
        Math.floor((1920 - 570) / 150) - 1;
    if ( items.length > 10 ) {
        const lines = [];
        let items1 = items.slice(0);
        for (;items1.length;){
            lines.push(items1.splice(0, tilesPerRow));
        }
        return lines;
    } else {
        const i = Math.ceil(items.length / 2);
        return [
            items.slice(0, i),
            items.slice(i),
        ];
    }
};